module.exports = {
	"articleTitle1": "Nate Wood: Pull up a chair at Palio",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Palio Ann Arbor",
	"articleLink1": "https://www.michigandaily.com/arts/11nate-wood-papa-palio07",
	"articleLink2": "https://www.michigandaily.com/content/palio-tempts-tastebuds",
	"articleSnippet1": "Nov 7, 2013 ... I wish someone had told me about Palio before the end of my junior year. \nWhenever I heard about Italian food in Ann Arbor, there was only ...",
	"articleSnippet2": "Apr 11, 2001 ... In Italy, the word \"Palio\" generally refers to the decorated banner that is \npresented to the winner of the summer horse race in Siena, Italy. In Ann ...",
	"foodRecommendations": [],
	"articleTitle2": "Palio tempts tastebuds",
	"address": "347 S Main St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.278255,
		"lng": -83.748299
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/palio.json
// module id = 941
// module chunks = 0